import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const OuterContainer = styled.div`
  display: flex;
  padding: ${o => o.theme.spacing(8, 2.5)};
  justify-content: center;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  align-self: stretch;
  ${fromMd} {
    padding: ${o => o.theme.spacing(10, 2.5)};
  }
`

export const Container = styled.section`
  ${TypeStyle.css.bodyLarge};
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 24px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  > * + * {
    margin-inline-start: ${o => o.theme.spacing(10)};
  }
`

export const SelectedGender = styled.span`
  display: inline-block;
  &::after {
    background: black;
    content: '';
    display: block;
    height: 2px;
    position: relative;
    top: 3px;
  }
`

export const UnselectedGender = styled.span`
  cursor: pointer;
`
